import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import { SideNav } from "components";
import http from "services/httpService";
import { parentalProducts, updateFlexUserPlanIds, uploadFile } from "utlis/utils";
import {
  BaseDropdown,
  MainBody,
  PageTitle,
  OverlayLoader,
  LargeButton,
} from "components/core";
import { productPricingSchema, productPricingValues } from "../schemas";
import UploadFile from "components/UploadFile";
import { WidthLimiter } from "pages/PlanSetup/styles";
import useFlex from "hooks/useFlex";
import { useLocation } from "react-router";
import { Divider } from "@mui/material";
import AttributesTable from "components/Flex/AttributesTable";

const GhiPricingSetup = () => {
  const { next, getProductDetails } = useFlex();
  const { state } = useLocation();

  const [attrDescriptionError, setAttrDescriptionError] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [insurers, setInsurers] = useState({}); // insurers list
  const [dependentType, setDependentType] = useState({});
  const [premiumOptions, setPremiumOptions] = useState({});
  const [dependentLock, setDependentLock] = useState({});
  const [maxChild, setMaxChild] = useState({});
  const [parentSet, setParentSet] = useState({});
  const [fileError, setFileError] = useState(false);
  const [file, setFile] = useState();
  const [documentId, setDocumentId] = useState();
  const [empAttribute, setEmpAttribute] = useState(); // attributes list
  const [selectedAttributes, setAttributes] = useState(); // selected attributes list
  const [dependentSensitive, setDependentSensitive] = useState();
  useEffect(() => {
    (async function () {
      await fetchInsurers();
    })();
  }, [state.key]);
  const uploadedFileValues = (values, file) => {
    setEmpAttribute(values);
    setFile(file);
  };

  const fetchInsurers = async () => {
    try {
      setLoading(true);
      const { data } = await http.get(
        `business/get_flex_product_setup_details/`,
        {
          params: {
            product: state.product,
          },
        }
      );
      setInsurers(data.insurers);
      setDependentType(data.dependent_type);
      setPremiumOptions(data?.dependent_wise_premium_calculation_options)
      setDependentLock(data.dependent_lock_options);
      setMaxChild(data.number_of_children_options);
      setParentSet(data.parents_set_eligible_options);
      if(data.tpas) {
        localStorage.setItem("tpa_details", JSON.stringify(data.tpas));
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  const getOptions = (details) => {
    if (!details) return [];
    return details.map(({ display_name, value }) => ({
      label: display_name,
      value,
    }));
  };
  const handleError = () => {
    if (!file)
      setFileError((prev) => ({
        ...prev,
        file: true,
      }));
    if (!documentId)
      setFileError((prev) => ({
        ...prev,
        document: true,
      }));
  };

  const handleAttributeDescriptionErrors = (values) => {
    const errors = [];
    if (!empAttribute) return false;
    empAttribute.forEach((item, index) => {
      if (
        (selectedAttributes[item] === 0 || selectedAttributes[item] === 1) &&
        !values.attribute_definition_mapping[item]
      ) {
        errors.push(item);
      }
    });
    setAttrDescriptionError(errors);
    return errors.length > 0;
  };

  const handleSubmit = async (values) => {
    const isError = handleAttributeDescriptionErrors(values);
    // if (isError) return;
    const [options] = JSON.parse(localStorage.getItem("completed_product_list"))
      .filter((item) => item.product === state.product)
      .map((item) => item.option);
    const business_user_id = localStorage.getItem("id");
    const rateChartId = file && (await uploadFile(file, "premiums_excel"));
   
    let select = {}, display = {};
    selectedAttributes && empAttribute.forEach((item, index) => {
      if(selectedAttributes[item] === 0){
        select[item]=true;
        display[item]=true
      }else if(selectedAttributes[item] === 1){
        select[item]=false;
        display[item]=true
      }else{
        select[item]=false;
        display[item]=false
      }
    });
    const { attribute_definition_mapping } = values;
    try {
      setLoading(true);
      const payload = {
        business_type: state.product || "health_insurance",
        business_user_id,
        insurer_name: values.insurer,
        employee_policy_document_id: documentId,
        // dependent_type: values.dependent_type,
        dependent_wise_premium_calculation: values.dependent_wise_premium_calculation,
        rate_chart_id: rateChartId, // file id of the document uploaded
        employee_visibility_mapping: display,//superset - this contains the values which the user can see but cannot select
        employee_selectable_mapping: select,//subset - employee can select these values on his/her app
        attribute_definition_mapping: attribute_definition_mapping,
        dependent_sensitive_mapping : dependentSensitive,
        mandatory: options == 0 ? true : false,
      };
      // if(!(getProductDetails(state.product).value === 'parental_cover'))payload.dependent_type= values.dependent_type;
      if(!(parentalProducts.includes(getProductDetails(state.product).value)))payload.dependent_type= values.dependent_type;
      if (values.are_dependents_locked || values.are_dependents_locked === false)
        payload.are_dependents_locked = values.are_dependents_locked;
      if (values.max_children_allowed)
        payload.max_children_allowed = values.max_children_allowed;
      if (values.are_different_parent_set_allowed != null)
        payload.are_different_parent_set_allowed =
          values.are_different_parent_set_allowed;
      if(getProductDetails(state.product).value === 'health_insurance'){
        payload.attributes = empAttribute;
        localStorage.setItem('setup_plan_payload', JSON.stringify(payload));
        next();
      }else{
        let { data } = await http.post("/business/setupplan/", payload);
        updateFlexUserPlanIds(
          state.product || "health_insurance",
          data.userplan_id
        );
        localStorage.setItem("flex_userplan_id", data.userplan_id);
        next();
      }
      
    } catch (error) {
      console.log(error);
    } finally {
      setEmpAttribute();
      setLoading(false);
    }
  };
  return (
    <section>
      {isLoading ? (
        <OverlayLoader />
      ) : (
        <>
          <SideNav />
          <MainBody style={{ position: "relative", minHeight: "100vh" }}>
            <WidthLimiter>
              <PageTitle
                title={`Setup ${getProductDetails(state.product).display_name}`}
              />
              <Formik
                enableReinitialize={true}
                initialValues={productPricingValues}
                validationSchema={productPricingSchema((getProductDetails(state.product).value))}
                onSubmit={handleSubmit}
              >
                {(formikProps) => (
                  <Form style={{ paddingBottom: "80px" }}>
                    <BaseDropdown
                      fontSize="14"
                      label={
                        getProductDetails(state.product).value ===
                        "health_checkup"
                          ? "Vendor"
                          : "Insurer"
                      }
                      options={getOptions(insurers)}
                      formikProps={{ ...formikProps, name: "insurer" }}
                    />
                    {
                      //  !(getProductDetails(state.product).value === 'parental_cover') &&
                       !(parentalProducts.includes(getProductDetails(state.product).value)) &&
                      <div style={{ marginTop: "2rem" }}>
                        <BaseDropdown
                          fontSize="14"
                          label="Select Dependent Type"
                          options={getOptions(dependentType)}
                          formikProps={{ ...formikProps, name: "dependent_type" }}
                        />
                      </div>
                    }
                    {formikProps &&
                      formikProps.values &&
                      formikProps.values.dependent_type &&
                      ["ESC", "ESCP1", "ESCP2"].includes(
                        formikProps.values.dependent_type) && (
                        <>
                          <div style={{ marginTop: "2rem" }}>
                            <BaseDropdown
                              fontSize="14"
                              label="Choose maximum number of children allowed"
                              options={getOptions(maxChild)}
                              formikProps={{
                                ...formikProps,
                                name: "max_children_allowed",
                              }}
                            />
                          </div>
                          <div style={{ marginTop: "2rem" }}>
                            <BaseDropdown
                              fontSize="14"
                              label="Enable employees to modify the list of dependents provided by the employer?"
                              options={getOptions(dependentLock)}
                              formikProps={{
                                ...formikProps,
                                name: "are_dependents_locked",
                              }}
                            />
                          </div>
                        </>
                      )}
                    {
                      // getProductDetails(state.product).value === 'parental_cover' &&
                      parentalProducts(getProductDetails(state.product).value) &&
                      <div style={{ marginTop: "2rem" }}>
                        <BaseDropdown
                          fontSize="14"
                          label="Enable employees to modify the list of dependents provided by the employer?"
                          options={getOptions(dependentLock)}
                          formikProps={{
                            ...formikProps,
                            name: "are_dependents_locked",
                          }}
                        />
                      </div>
                    }
                    {(formikProps &&
                      formikProps.values &&
                      formikProps.values.dependent_type &&
                      (formikProps.values.dependent_type === "ESCP2") || 
                      // (getProductDetails(state.product).value === 'parental_cover') ) && (
                      (parentalProducts(getProductDetails(state.product).value)) ) && (
                        <div style={{ marginTop: "2rem" }}>
                          <BaseDropdown
                            fontSize="14"
                            label="Allow inclusion of both parents and in-laws within the same product offering?"
                            options={getOptions(parentSet)}
                            formikProps={{
                              ...formikProps,
                              name: "are_different_parent_set_allowed",
                            }}
                          />
                        </div>
                      )}
                    <div style={{ marginTop: "2rem" }}>
                      <BaseDropdown
                        fontSize="14"
                        label="Calculate premium for each dependent"
                        options={getOptions(premiumOptions)}
                        formikProps={{ ...formikProps, name: "dependent_wise_premium_calculation" }}
                      />
                    </div>
                    <UploadFile
                      label="Upload Benefit Manual"
                      text="Upload PDF"
                      format="pdf"
                      type="policy_document"
                      onSelect={setDocumentId}
                      showError={fileError.document}
                    />
                    <div style={{ margin: "4rem 0rem 0rem 0rem" }}>
                      <Divider />
                    </div>
                    <UploadFile
                      label="Upload Rate Chart"
                      text="Upload Excel"
                      format="excel"
                      customApi="/business/get_product_attributes/"
                      customPostData={formikProps.values?.dependent_wise_premium_calculation}
                      customData={uploadedFileValues}
                      sampleFile="FlexRateChart"
                      showError={fileError.file}
                    />
                    {!!empAttribute && (
                      <AttributesTable
                        attrDescriptionError={attrDescriptionError}
                        attributes={empAttribute}
                        formikProps={formikProps}
                        onAttrChange={setAttributes}
                        dependentSensitive={setDependentSensitive}
                      />
                      // <EmpAttributes
                      //   attrDescriptionError={attrDescriptionError}
                      //   formikProps={formikProps}
                      //   attributes={empAttribute}
                      //   onChange={setAttributes}
                      //   onSelectableChange={setAttributesForSelectable}
                      // />
                    )}
                    <div
                      style={{
                        bottom: "40px",
                        position: "absolute",
                        width: "calc(100% - 8rem)",
                        maxWidth: "800px",
                      }}
                    >
                      <LargeButton
                        type="submit"
                        label="Save & Next"
                        marginTop="2rem"
                        onClick={handleError}
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </WidthLimiter>
          </MainBody>
        </>
      )}
    </section>
  );
};

export default GhiPricingSetup;
